<template>
  <div class="add-credentials-card" v-on:click="addNewCredentials">
    <img class="plus-image" :src="require('@/assets/onboarding/icons/icon-add.svg')">
    <div class="title">{{ title }}</div>
  </div>
</template>

<script>
import sourceToLogo from '../../utils/sourcesToLogo';

export default {
  name: 'addCredentialsCard',
  props: {
    title: {
      type: String,
      required: true,
    },
    addNewCredentials: {
      type: Function,
      required: true,
    },
  },
  computed: {
    logoPath() {
      return sourceToLogo[this.sourceName];
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../scss/mixins';

  .add-credentials-card {
    height: 185px;
    padding: 30px 0;
    border: dashed 1px $riseup_blue;
    border-radius: 10px;
    width: 100%;
    background-color: $riseup-white;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    cursor: pointer;

    .plus-image {
      height: 47px;
    }

    .title {
      font-size: 16px;
      font-weight: bold;
      color: $riseup_blue;
    }
  }
</style>
